import AvatarUpload from './AvatarUpload'

export default AvatarUpload
// eslint-disable-next-line import/export
export * from './AvatarUpload'
